import { useEffect, useMemo } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

import { useDispatch, useSelector } from "react-redux";
import { firebase, setSomaticCells } from "store/slices/firebaseSlice";
import somaticCellsTableData from "./data/somaticCellsTableData";
import DataTable from "examples/Tables/DataTable";
import { collection, onSnapshot } from "firebase/firestore";
import { db } from "services/firebase";
import { tableSelector } from "store/slices/tableSlice";

function SomaticCells() {
  const { somaticCellsData, clientId } = useSelector(firebase);
  const { startDate, endDate } = useSelector(tableSelector);
  const dispatch = useDispatch();
  useEffect(() => {
    if (!clientId) return;
    const unsubscriptions = {};
    const unsubscribeDevices = onSnapshot(
      collection(db, "Results", clientId, "devices"),
      (devices) => {
        for (const device of devices.docs) {
          const unsubscribeMeasurements = onSnapshot(
            collection(db, "Results", clientId, "devices", device.id, "scc_measurement"),
            (measurements) => {
              let data = [];
              for (const num of measurements.docs) {
                const result = num.data();
                if (result.date && result.date.toDate) {
                  result.date = result.date.toDate().toLocaleString();
                }
                data = [...data, result];
              }
              dispatch(setSomaticCells({ deviceId: device.id, data }));
            }
          );
          unsubscriptions[device.id] = unsubscribeMeasurements;
        }
      }
    );

    return () => {
      unsubscribeDevices();
      Object.values(unsubscriptions).forEach((unsubscribeMeasurements) => {
        if (unsubscribeMeasurements) {
          unsubscribeMeasurements();
        }
      });
    };
  }, [clientId]);
  const { columns = [], rows = [] } = useMemo(
    () => somaticCellsTableData(somaticCellsData, startDate, endDate),
    [somaticCellsData, startDate, endDate]
  );

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  Somatic Cells (Client ID: {clientId})
                </MDTypography>
              </MDBox>
              <MDBox pt={3}>
                <DataTable
                  table={{ columns, rows }}
                  isSorted
                  isDraggable
                  entriesPerPage={false}
                  showTotalEntries={false}
                  noEndBorder
                  pagination={{ variant: "gradient", color: "info" }}
                  canHideColumns
                  canFilterByDate
                  columnNamespace="somatic"
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default SomaticCells;
